import { Component, OnInit } from "@angular/core";
import { IaithService } from "src/app/craidd/gwasanaethau/iaith/iaith.service";
import { Location, AsyncPipe } from "@angular/common";
import { Observable, Subscription } from "rxjs";
import { MediaObserver, MediaChange } from "@ngbracket/ngx-layout";
import { DeviceDetectorService } from "ngx-device-detector";
import { Router } from "@angular/router";
import { filter, map, startWith } from "rxjs/operators";
import { DilysuService } from "src/app/craidd/gwasanaethau/defnyddiwr/dilysu.service";
import { SidenavService } from "src/app/craidd/gwasanaethau/system/sidenav.service";
import { environment } from "src/environments/environment";
import { TenantMath } from "src/app/craidd/modelau/defnyddiwr/rol";
import { IaithRouterService } from "src/app/craidd/gwasanaethau/iaith/iaith-router.service";
import { StorfaDefnyddiwrService } from "src/app/craidd/gwasanaethau/system/storfa-defnyddiwr.service";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import { MatIconButton, MatButton } from "@angular/material/button";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { MatRipple } from "@angular/material/core";
import { MatMenuTrigger, MatMenu, MatMenuItem } from "@angular/material/menu";
import { NavbarDefnyddiwrComponent } from "../navbar-defnyddiwr/navbar-defnyddiwr.component";
import { LlwythwrComponent } from "../llwythwr/llwythwr.component";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-navbar",
    templateUrl: "./navbar.component.html",
    styleUrls: ["./navbar.component.scss"],
    imports: [
        MatToolbar,
        MatToolbarRow,
        MatIconButton,
        FaIconComponent,
        MatRipple,
        MatMenuTrigger,
        MatMenu,
        MatMenuItem,
        NavbarDefnyddiwrComponent,
        MatButton,
        LlwythwrComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class NavbarComponent implements OnInit {
  dangosBotwm = true;

  watcher: Subscription;

  prawf = !environment.production;

  cyddiedMewngofnodi = false;

  enwTenant$: Observable<string>;
  enwTenant: string = "";

  constructor(
    public location: Location,
    private router: Router,
    private dilysuService: DilysuService,
    private iaithService: IaithService,
    private iaithRouterService: IaithRouterService,
    private sidenavService: SidenavService,
    mediaObserver: MediaObserver,
    private deviceService: DeviceDetectorService,
    private storfaDefnyddiwrService: StorfaDefnyddiwrService,
  ) {
    // https://www.npmjs.com/package/ngx-device-detector
    const isTablet = this.deviceService.isTablet();

    if (isTablet) {
      this.dangosBotwm = false;
    } else {
      this.watcher = mediaObserver
        .asObservable()
        .pipe(
          filter((changes: MediaChange[]) => changes.length > 0),
          map((changes: MediaChange[]) => changes[0]),
        )
        .subscribe((change: MediaChange) => {
          if (change.mqAlias === "sm" || change.mqAlias === "xs") {
            this.dangosBotwm = false;
          } else {
            this.dangosBotwm = true;
          }
        });
    }
  }

  ngOnInit() {
    this.enwTenant$ = this.storfaDefnyddiwrService.storfaDefnyddiwr$.pipe(
      startWith(true),
      map(() => this.storfaDefnyddiwrService.nolEnwTenant()),
    );

    this.enwTenant$.subscribe((tenant) => {
      this.enwTenant = tenant;
    });

    const pathname = location.pathname.split("/")[1];

    if (pathname === "dyddiol") {
      this.cyddiedMewngofnodi = true;
    }

    if (pathname === "damwain") {
      this.cyddiedMewngofnodi = true;
    }
  }

  mewngofnodi() {
    this.dilysuService.mewngofnodi();
  }

  wediMewngofnodi() {
    return this.dilysuService.wediMewngofnodi();
  }

  desgGymorth() {
    this.router.navigate([this.iaithRouterService.cyfieithuLlwybr("/cymorth")]);
  }

  newidIaith(iaith: string) {
    this.iaithService.newidIaithSystem(iaith);
  }

  toggle() {
    this.sidenavService.toggle();
  }

  nolLogo(): string {
    switch (this.enwTenant) {
      case TenantMath.Gwynedd:
        return "assets/lluniau/navbar_cg.png";
      case TenantMath.PriffyrddGwynedd:
        return "assets/lluniau/navbar_cg.png";
      case TenantMath.Fflint:
        return "assets/lluniau/navbar_fflint.png";
      case TenantMath.FflintSmallPlant:
        return "assets/lluniau/navbar_fflint.png";
      case TenantMath.Conwy:
        return "assets/lluniau/navbar_conwy.png";
      default:
        return "";
    }
  }
}
